import { Pagination, paginationToParams } from '../Pagination';

export interface CouponFilter {
  search?: string;
  pagination: Pagination;
}

export const couponFilterToParams = (couponFilter: CouponFilter) => ({
  search: couponFilter.search || undefined,
  ...paginationToParams(couponFilter.pagination),
});
